class ProductDetailsRequest{

    ProductDetailsURL(code){
        return process.env.REACT_APP_BASEURL+"ProductDetails/"+code
    }
}

export const {ProductDetailsURL}=new ProductDetailsRequest()